import { STOCK_CATEGORIES, stockCategorySelectOptions, mergedStockCategories } from './stockCategories';
import { BAR_STOCK_CATEGORIES, barCategorySelectOptions, mergedBarCategories } from './barStockCategories';
import {
  PHARMACY_STOCK_CATEGORIES,
  pharmacyCategorySelectOptions,
  mergedPharmacyCategories,
} from './pharmacyStockCategories';
import {
  factoryCategorySelectOptions,
  mergedFactoryCategories,
} from './factoryStockCategories';
import {
  AUTOMOTIVE_STOCK_CATEGORIES,
  automotiveCategorySelectOptions,
  mergedAutomotiveCategories,
} from './automotiveStockCategories';

function businessTypeCode(user) {
  return user?.tenant?.businessType || '';
}

function catalogForType(code) {
  if (code === 'bar_pub' || code === 'bar_pub_with_wakala') return BAR_STOCK_CATEGORIES;
  if (code === 'pharmacy') return PHARMACY_STOCK_CATEGORIES;
  if (code === 'automotive_products') return AUTOMOTIVE_STOCK_CATEGORIES;
  if (code === 'stationary') return STOCK_CATEGORIES;
  return STOCK_CATEGORIES;
}

/** @returns {{ value: string, label: string }[]} */
export function categorySelectOptionsForUser(user) {
  const code = businessTypeCode(user);
  if (code === 'brick_factory') return factoryCategorySelectOptions();
  if (code === 'bar_pub' || code === 'bar_pub_with_wakala') return barCategorySelectOptions();
  if (code === 'pharmacy') return pharmacyCategorySelectOptions();
  if (code === 'automotive_products') return automotiveCategorySelectOptions();
  if (code === 'stationary') return stockCategorySelectOptions();
  return stockCategorySelectOptions();
}

/** @param {{ category?: string }[]} products */
export function mergedCategoriesForUser(user, products) {
  const code = businessTypeCode(user);
  if (code === 'brick_factory') return mergedFactoryCategories(products);
  if (code === 'bar_pub' || code === 'bar_pub_with_wakala') return mergedBarCategories(products);
  if (code === 'pharmacy') return mergedPharmacyCategories(products);
  if (code === 'automotive_products') return mergedAutomotiveCategories(products);
  return mergedStockCategories(products);
}

export { catalogForType };
